const LOG_ERRORS = false;

export const logError = (errorLog: any): void => {
  // eslint-disable-next-line no-console
  LOG_ERRORS && console.error(errorLog);
};
